import PropTypes from 'prop-types';
import React from 'react';
import Modal from 'components/Modal';
import ModalHeader from 'components/ModalHeader';
import ModalHeaderWithClose from 'components/ModalHeaderWithClose';
import {FormattedMessage} from 'react-intl';
import Icon from 'components/Icon';
import './FilterGroupEditorModal.css';

class FilterGroupEditorModal extends React.Component {
  render() {
    const {
      filterGroups,
      selectedFilterGroupIds,
      isOpen,
      onRequestModalClose,
      onSelect,
    } = this.props;

    const selectedIcon = (
      <div>
        <Icon icon={Icon.OPTIONS.CHECK} size={Icon.SIZES.MICRO} />
      </div>
    );

    const options = filterGroups.map(filterGroup => (
      <div
        key={filterGroup.filterGroupId}
        onClick={onSelect.bind(this, filterGroup.filterGroupId)}
        className="FilterGroupEditorModal__Option"
      >
        <div className="FilterGroupEditorModal__OptionText">
          {filterGroup.name}
        </div>
        {selectedFilterGroupIds.has(filterGroup.filterGroupId)
          ? selectedIcon
          : null}
      </div>
    ));

    const modalIcon = (
      <a className="FilterGroupEditorModal__Close">
        <FormattedMessage
          id="FilterGroupEditorModal__Close"
          description="Action to indicate a user is finished selecting filter options"
          defaultMessage="Done"
        />
      </a>
    );

    return (
      <Modal isOpen={isOpen}>
        <ModalHeaderWithClose onClose={onRequestModalClose} icon={modalIcon}>
          <ModalHeader>
            <FormattedMessage
              id="FilterGroupEditorModal__Header"
              description="Title for PDP picker modal"
              defaultMessage="Personalized Data Permissions"
            />
          </ModalHeader>
        </ModalHeaderWithClose>
        {options}
      </Modal>
    );
  }
}

FilterGroupEditorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestModalClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  filterGroups: PropTypes.array.isRequired,
  selectedFilterGroupIds: PropTypes.instanceOf(Set),
};

export default FilterGroupEditorModal;
